import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {Range} from "@/modules/redactor/models/utils/Range";
import { ItemKindModel } from "@/modules/redactor/models/item/core/ItemKindModel";
import {ItemBoostAction} from "@/modules/redactor/models/item/boost/ItemBoostAction";

export class ItemBoostRule extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemBoostRule, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemBoostRule, v);
            }
        );
    }

    constructor() {
        super();

        this._kind = null;
        this._level = new Range(0, 0);
        this._amount = 0;

        this._action = ItemBoostAction.NONE;
        this._quantity = 1;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    get action() {
        return this._action;
    }

    set action(value) {
        this._action = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    collide(rule) {
        return this.kind.equal(rule.kind) && this.level.collide(rule.level);
    }

    valid() {

        if (!ItemKindModel.is(this.kind)) {
            return false;
        }

        if (!this.level || !this.level.valid()) {
            return false;
        }

        if (!Number.isInteger(this.amount) || this.amount <= 0) {
            return false;
        }

        if (ItemBoostAction.isNone(this.action)) {
            return false;
        }

        if (!Number.isInteger(this.quantity) || this.quantity <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !ItemKindModel.is(this.kind);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemBoostRule());
        } else if (target instanceof ItemBoostRule) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemBoostRule, {
    _kind: alias("kind", ItemKindModel.schema()),
    _level: alias("level", Range.schema()),
    _amount: alias("amount", Schema.primitive()),
    _action: alias("action", ItemBoostAction.schema()),
    _quantity: alias("quantity", Schema.primitive())
});